import { CommonError, CommonsStore, RemoteApi } from "lego-gui-lib";
import { action, observable } from "mobx";
import { createContext } from "react";
import { mainStore } from "../mainStore";

interface ApiVersion {
  commitId: string;
  commitTime: string;
  buildTime: string;
  branch: string;
  site: string;
  tagName: string;
  backgroundColor: string
}

export class Version {
  private commons: CommonsStore;
  private remoteApi: RemoteApi;
  private DEFAULT_BG_COLOR = "#fff";

  @observable public apiVersion: ApiVersion;

  public constructor(api: RemoteApi, commons: CommonsStore) {
    this.commons = commons;
    this.remoteApi = api;
    this.apiVersion = {
      branch: "",
      buildTime: "",
      commitId: "",
      commitTime: "",
      site: "",
      tagName: "",
      backgroundColor: this.DEFAULT_BG_COLOR
    };
  }

  @action
  public setApiVersion(apiVersion: unknown) {
    this.validateBackgroundColor(apiVersion as ApiVersion);
    this.apiVersion = apiVersion as ApiVersion;
  }

  @action
  public fetchVersion: () => Promise<void> = async () => {
    try {
      const version = await this.remoteApi.getMethod("/version", {});
      this.setApiVersion(version);
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
  };

  private validateBackgroundColor(apiVersion: ApiVersion) {
    if(apiVersion.backgroundColor != "" && !(/^#([0-9A-Fa-f]{3}){1,2}$/i.test(apiVersion.backgroundColor))){
      this.commons.newError({message:"Invalid background color received from API. Loaded default theme"} as CommonError);
    }
  }
}

const version = new Version(mainStore.api, mainStore.commons);
export const versionContext = createContext(version);
